interface ModalProps {
  title?: string;
  children: React.ReactNode;
  showClose?: boolean;
  onClose: () => void;
}

export default function Modal({
  title,
  children,
  showClose = true,
  onClose,
}: ModalProps) {
  return (
    <div className="fixed inset-0 z-[51] flex items-center justify-center">
      <div className="bg-white z-[51] rounded shadow-lg p-4 md:p-6 mx-auto max-h-[90vh] max-w-[95vw] md:max-w-[70vw] lg:max-w-[50vw]">
        {<b>{title}</b>}
        {showClose && (
          <button
            title="close"
            type="button"
            className="float-right text-gray-500 hover:text-black"
            onClick={onClose}
          >
            <CloseX />
          </button>
        )}
        <div className="clear-both">{children}</div>
      </div>
      <div
        className="fixed inset-0 bg-black opacity-25"
        onClick={onClose}
      ></div>
    </div>
  );
}

function CloseX() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="w-7 h-7 mb-3 md:mb-0 md:w-6 md:h-6"
    >
      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
    </svg>
  );
}
